const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SummaryCommandV2: any = {
    UpdateSummaryV2: Backofficebff + '/v2/PaymentConsolidation/update-summary-item',
    AxaptaTransferSummaryV2: Backofficebff + '/v2/PaymentConsolidation/summary-send-to-axapta',
    GetSummaryListV2: Backofficebff + '/v2/PaymentConsolidation/get-payment-consolidation',
};
